document.addEventListener("DOMContentLoaded", () => {
  if (window.variantStrings && !window.variantStrings._addToCartDefault) {
    window.variantStrings._addToCartDefault = window.variantStrings.addToCart
  }

  const currentDate = () => {
    const idInput = document.querySelector(".product-variant-id")
    return idInput ? window.preorderVariants?.[idInput.value] : null
  }

  const applyPreorder = () => {
    const date = currentDate()

    if (window.variantStrings) {
      window.variantStrings.addToCart = date
        ? "Preorder"
        : window.variantStrings._addToCartDefault
    }

    const input = document.querySelector("[data-preorder-input]")
    if (input) {
      input.disabled = !date
      input.value = date ? `Ships from ${date}` : ""
    }

    // Hide inventory status while on pre-order
    const inventoryEl = document.querySelector(".product__inventory")
    if (inventoryEl) {
      inventoryEl.hidden = !!date
    }

    if (date) {
      document.querySelectorAll(".product-form__submit").forEach(btn => {
        const span = btn.querySelector("span")
        if (span && !btn.disabled && span.textContent.trim() !== "Preorder") {
          span.textContent = "Preorder"
        }
      })
    }
  }

  // debounced permanent watcher
  let timer
  new MutationObserver(() => {
    clearTimeout(timer)
    timer = setTimeout(applyPreorder, 50)
  }).observe(document.body, { childList: true, characterData: true, subtree: true })

  applyPreorder()
})
